// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1wa-3","label":"Category_label__-Ideo","content":"Category_content__mW8ui","header":"Category_header__ie12L","location":"Category_location__16dTD"};